import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import $ from 'jquery';
import Notifications, {notify} from 'react-notify-toast';
import {Api} from '../../../utils/Variables';
import axios from 'axios';
import {message, Spin} from 'antd';
import {Row, Col, Card} from 'react-bootstrap';

import PsContext from '../../context/PsContext';


class Login extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			btnText: 'Login',
			showLoader: false,
			isRedirect: false,
			loggedUser: [],
		}
		
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}
	
	componentDidMount(){
		
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		try{			
			 this.setState({showLoader: true, btnText: 'Validating..'});
			axios.post(Api.Url+'v1/login', $("#frmLogin").serialize()).then(res=>{
				
				if(res['data'].status === '1'){
					
					this.context.updateLogin(res['data'].api, res['data'].data, res['data'].company);
					this.setState({showLoader: false, btnText: 'Login'});
				}
				else{
					message.error(res['data'].message || 'Error');
					this.setState({showLoader: false, btnText: 'Login'});
				}
			});	 
		}
		catch(error){
			console.log(error);
			this.setState({showLoader: false, btnText: 'Login'});
		}
	}
	
	componentWillUpdate(){
		
	}
	
	render(){

		//if(this.state.isRedirect || getlsItem('user_logged')=='YES'){
		
		if(this.context.state.logged=='YES'){
			return(<Redirect to="/app" />);
		}
		
		return(
		
			<Spin spinning={this.state.showLoader} >
			<div className="">
					
			  <div className="background-shape"></div>
			  <div className="container">
				<div className="row justify-content-center">
				  <div className="col-12 col-sm-9 col-md-7 col-lg-6 col-xl-5">
					<img className="big-logo" src="img/core-img/logo-white.png" alt="" />
						
						<Card>
						<Card.Body>
						
						<div className="register-forms mt-5 px-4">
						  <form action="" method="post" id="frmLogin" onSubmit={this.handleFormSubmit} >
							<div className="form-group text-start mb-4"><span>Username</span>
							  <label for="username"></label>
							  <input className="form-control" id="username" type="text" placeholder="Username" name="i__userName" required />
							</div>
							<div className="form-group text-start mb-4"><span>Password</span>
							  <label for="password"></label>
							  <input className="form-control" id="password" type="password" placeholder="Password" name="i__password" required/>
							</div>
							<button className="btn btn-success btn-lg w-100" type="submit">Log In</button>
						  </form>
						</div>
						
						</Card.Body>
						</Card>
									
					
					{/*<div className="view-as-guest mt-3"><a className="btn" href="home.html">View as Guest</a></div>*/}
				  </div>
				</div>
			  </div>
			  			  
			</div>
			</Spin>
		);
	}
	
}
export default Login;
